(function(){
  "use strict";
  var scrim = function(){ return document.querySelector('[data-scrim]'); };
  function lock(){ document.body.style.overflow='hidden'; }
  function unlock(){ document.body.style.overflow=''; }

  /* ---------- Inventory / cart toast ---------- */
  (function(){ var s=document.createElement('style'); s.textContent='.sk-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:#1c1c1c;color:#fff;padding:13px 20px;border-radius:12px;font-size:14px;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.25);z-index:200;opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;max-width:90vw;text-align:center}.sk-toast.show{opacity:1;transform:translateX(-50%) translateY(0)}[data-cart-body].is-updating .ci-price,[data-cart-body].is-updating .cart-total,[data-cart-body].is-updating .ship-bar{opacity:.55;transition:opacity .15s ease}'; document.head.appendChild(s); })();
  function skCartToast(msg){ var t=document.querySelector('[data-sk-toast]'); if(!t){ t=document.createElement('div'); t.setAttribute('data-sk-toast',''); t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); t.className='sk-toast'; document.body.appendChild(t); } t.textContent=msg; t.classList.add('show'); clearTimeout(t._tm); t._tm=setTimeout(function(){ t.classList.remove('show'); }, 4000); }
  window.skCartToast = skCartToast;

  /* ---------- Mobile nav ---------- */
  var mnav = document.querySelector('[data-mnav]');
  function openNav(){ mnav&&mnav.classList.add('open'); var s=scrim(); s&&s.classList.add('open'); lock(); }
  function closeNav(){ mnav&&mnav.classList.remove('open'); var s=scrim(); s&&s.classList.remove('open'); unlock(); }
  document.querySelectorAll('[data-open-mnav]').forEach(function(b){ b.addEventListener('click', openNav); });
  document.querySelectorAll('[data-close-mnav]').forEach(function(b){ b.addEventListener('click', closeNav); });

  document.querySelectorAll('[data-macc-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){ var p=btn.nextElementSibling; if(p){ p.style.display=(p.style.display==='block')?'none':'block'; } });
  });

  /* ---------- Mega menu (desktop) ---------- */
  var header=document.querySelector('.site-header');
  if(header){
    var panel=header.querySelector('.mega[data-mega-panel]');
    function closeMega(){ panel&&panel.classList.remove('open'); }
    header.querySelectorAll('.nav-link[data-mega]').forEach(function(t){
      t.addEventListener('mouseenter', function(){ panel&&panel.classList.add('open'); });
      t.addEventListener('focus', function(){ panel&&panel.classList.add('open'); });
    });
    header.querySelectorAll('.nav-link:not([data-mega]), .header-actions, .logo').forEach(function(el){
      el.addEventListener('mouseenter', closeMega);
      el.addEventListener('focusin', closeMega);
    });
    if(panel){
      header.addEventListener('mouseleave', closeMega);
      panel.addEventListener('mouseenter', function(){ panel.classList.add('open'); });
      panel.addEventListener('mouseleave', closeMega);
    }
  }

  /* ---------- Predictive search ---------- */
  var sov = document.querySelector('[data-search-overlay]');
  if(sov){
    var sInput = sov.querySelector('[data-search-input]');
    var sResults = sov.querySelector('[data-search-results]');
    function openSearch(){ sov.hidden=false; requestAnimationFrame(function(){ sov.classList.add('open'); }); lock(); setTimeout(function(){ sInput&&sInput.focus(); }, 80); }
    function closeSearch(){ sov.classList.remove('open'); unlock(); setTimeout(function(){ sov.hidden=true; }, 250); }
    document.querySelectorAll('[data-open-search]').forEach(function(b){ b.addEventListener('click', openSearch); });
    document.querySelectorAll('[data-close-search]').forEach(function(b){ b.addEventListener('click', closeSearch); });
    sov.addEventListener('click', function(e){ if(e.target===sov) closeSearch(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !sov.hidden) closeSearch(); });
    var sTimer=null, lastQ='';
    function sroot(){ return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
    function fetchSuggest(q){
      var url = sroot()+'search/suggest?q='+encodeURIComponent(q)+'&section_id=predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function(r){ return r.text(); }).then(function(html){
        if(q!==lastQ) return;
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var inner=tmp.querySelector('.ps-wrap');
        if(sResults) sResults.innerHTML = inner ? inner.innerHTML : '';
      }).catch(function(){});
    }
    if(sInput){
      sInput.addEventListener('input', function(){
        clearTimeout(sTimer);
        var q=sInput.value.trim(); lastQ=q;
        if(q.length<2){ if(sResults) sResults.innerHTML=''; return; }
        sTimer=setTimeout(function(){ fetchSuggest(q); }, 220);
      });
    }
  }

  /* ---------- Filters drawer (mobile) ---------- */
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-open-filters]')){ var f=document.getElementById('filters'),fs=document.querySelector('.filter-scrim'); f&&f.classList.add('open'); fs&&fs.classList.add('open'); }
    if(e.target.closest('[data-close-filters]')){ var f2=document.getElementById('filters'),fs2=document.querySelector('.filter-scrim'); f2&&f2.classList.remove('open'); fs2&&fs2.classList.remove('open'); }
  });

  /* ---------- Announcement rotate ---------- */
  var items=document.querySelectorAll('.announce .ann-item');
  if(items.length>1){ var i=0; setInterval(function(){ items[i].classList.remove('on'); i=(i+1)%items.length; items[i].classList.add('on'); },3500); }

  /* ============================================================
     CART DRAWER
     - Adds never run twice: if /cart/add.js succeeded, a failed drawer refresh only
       retries the refresh; it never re-submits the form.
     - Stepper taps update the number at once and are batched per line (350ms), then sent
       one request at a time, so fast taps add up correctly and replies can't arrive
       out of order. Older drawer renders are dropped if a newer one was requested.
     - Every cart request has error handling and a message for the shopper.
     - On the cart page, drawer changes reload the page so both stay in sync;
       cart-page changes refresh the drawer (window.skRefreshDrawer).
     ============================================================ */
  function drawer(){ return document.querySelector('[data-cart]'); }
  function cartBody(){ return document.querySelector('[data-cart-body]'); }
  function onCartPage(){ return !!document.querySelector('[data-cart-qty]'); }
  var drawerStale=false;   /* true when the drawer HTML may be out of date */
  var renderSeq=0;         /* id of the newest drawer refresh request */
  var openWanted=false;    /* a refresh asked to open the drawer once it renders */

  function openCart(){ var d=drawer(); d&&d.classList.add('open'); var s=scrim(); s&&s.classList.add('open'); lock(); if(drawerStale){ refreshDrawer(false).catch(function(){}); } }
  function closeCart(){ var d=drawer(); d&&d.classList.remove('open'); var s=scrim(); s&&s.classList.remove('open'); unlock(); }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-scrim]')){ closeCart(); closeNav(); }
    if(e.target.closest('[data-open-cart]')){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-close-cart]')){ e.preventDefault(); closeCart(); }
  });

  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=n; el.style.display=n?'grid':'none'; }); }

  function refreshDrawer(open){
    var seq=++renderSeq;
    if(open) openWanted=true;
    var root=(window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    return fetch(root+'?sections=cart-drawer',{credentials:'same-origin'})
      .then(function(r){ if(!r.ok){ throw new Error('Drawer refresh failed ('+r.status+')'); } return r.json(); })
      .then(function(data){
        if(seq!==renderSeq) return; /* a newer refresh is on its way, this reply is out of date */
        var html=data && data['cart-drawer'];
        if(!html){ throw new Error('Drawer refresh returned no HTML'); }
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var freshBody=tmp.querySelector('[data-cart-body]');
        var curBody=cartBody();
        if(freshBody && curBody){ curBody.innerHTML=freshBody.innerHTML; }
        drawerStale=false;
        applyPending();
        if(openWanted){ openWanted=false; openCart(); }
      })
      .catch(function(err){
        if(seq===renderSeq){ drawerStale=true; }
        throw err;
      });
  }
  window.skRefreshDrawer=function(open){ return refreshDrawer(!!open).catch(function(){}); };

  function cartJson(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ if(!r.ok){ throw new Error('cart.js '+r.status); } return r.json(); }); }
  function updateCountFromCart(){ return cartJson().then(function(c){ setCount(c.item_count); }).catch(function(){}); }

  /* ---------- Add to cart (shared by product form, quick add and upsell) ---------- */
  function postAdd(payload, isJson){
    var addOk=false;
    var opts={method:'POST',headers:{'Accept':'application/json'},body:payload,credentials:'same-origin'};
    if(isJson){ opts.headers['Content-Type']='application/json'; }
    return fetch('/cart/add.js',opts)
      .then(function(r){
        if(r.ok){ addOk=true; return; }
        return r.json().catch(function(){ return {}; }).then(function(e){ throw (e||{}); });
      })
      .then(function(){ return refreshDrawer(true); })
      .then(updateCountFromCart)
      .then(function(){ if(onCartPage()){ window.location.reload(); } })
      .catch(function(err){
        if(addOk){
          /* The item IS in the bag; only the drawer refresh failed. Never add it again:
             update the count, open the drawer (which retries the refresh) and confirm. */
          if(onCartPage()){ window.location.reload(); return; }
          drawerStale=true;
          updateCountFromCart();
          openCart();
          skCartToast('Added to your bag.');
          return;
        }
        skCartToast((err && err.description) || 'Could not add to cart. Please check your connection and try again.');
      });
  }
  function addId(variantId, qty){
    return postAdd(JSON.stringify({id:variantId,quantity:qty||1}), true);
  }

  /* ---------- Quantity changes (drawer stepper + remove) ---------- */
  var pending={};    /* line key -> quantity the shopper wants, not yet saved */
  var timers={};     /* line key -> batching timer */
  var inflight=false;
  var idleCbs=[];
  var reloadWhenIdle=false;

  function setBusy(on){ var b=cartBody(); if(b){ b.classList.toggle('is-updating', on); b.setAttribute('aria-busy', on?'true':'false'); } }
  function hasPending(){ for(var k in pending){ if(Object.prototype.hasOwnProperty.call(pending,k)) return true; } return false; }
  function spanFor(key){
    var btns=document.querySelectorAll('[data-cart-body] [data-inc]');
    for(var i=0;i<btns.length;i++){ if(btns[i].getAttribute('data-inc')===key){ var st=btns[i].closest('.stepper'); return st ? st.querySelector('span') : null; } }
    return null;
  }
  /* After a re-render, show the quantities the shopper tapped that are still waiting to be saved. */
  function applyPending(){
    Object.keys(pending).forEach(function(k){
      var s=spanFor(k); if(!s) return;
      s.textContent=pending[k];
      if(pending[k]===0){ var line=s.closest('.cart-line'); if(line) line.style.opacity='.45'; }
    });
  }

  function change(key, qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty}),credentials:'same-origin'})
      .then(function(r){ return r.json().catch(function(){ return null; }).then(function(cart){ return {status:r.status, cart:cart}; }); })
      .then(function(res){
        var cart=res.cart;
        if(res.status>=400 || !cart){ skCartToast((cart && cart.description) || 'Could not update quantity.'); return; }
        if(qty>0 && cart.items){ for(var i=0;i<cart.items.length;i++){ if(cart.items[i].key===key && cart.items[i].quantity<qty){ skCartToast('Only '+cart.items[i].quantity+' left in stock.'); break; } } }
      }, function(){
        skCartToast('Could not update your bag. Please check your connection and try again.');
      })
      .then(function(){ return refreshDrawer(false).catch(function(){}); })
      .then(updateCountFromCart);
  }

  function idle(){
    var cbs=idleCbs; idleCbs=[];
    if(cbs.length){ cbs.forEach(function(fn){ fn(); }); return; }
    if(reloadWhenIdle){ reloadWhenIdle=false; window.location.reload(); }
  }

  /* Sends one saved quantity at a time. */
  function pump(){
    if(inflight) return;
    var ready=Object.keys(pending).filter(function(k){ return !timers[k]; });
    if(!ready.length){ if(!hasPending()) idle(); return; }
    var key=ready[0], qty=pending[key];
    delete pending[key];
    inflight=true; setBusy(true);
    if(onCartPage()) reloadWhenIdle=true;
    change(key, qty)
      .catch(function(){})
      .then(function(){ inflight=false; setBusy(hasPending()); pump(); });
  }

  function queueChange(key, qty, delay){
    if(!key) return;
    pending[key]=qty;
    var s=spanFor(key);
    if(s){ s.textContent=qty; if(qty===0){ var line=s.closest('.cart-line'); if(line) line.style.opacity='.45'; } }
    setBusy(true);
    clearTimeout(timers[key]);
    timers[key]=setTimeout(function(){ delete timers[key]; pump(); }, delay);
  }

  document.addEventListener('click', function(e){
    var inc=e.target.closest('[data-inc]'); var dec=e.target.closest('[data-dec]');
    var rm=e.target.closest('[data-remove]'); var addv=e.target.closest('[data-add-variant]');
    if(inc||dec){
      var key=(inc||dec).getAttribute(inc?'data-inc':'data-dec');
      var cur;
      if(Object.prototype.hasOwnProperty.call(pending,key)){ cur=pending[key]; }
      else { var line=(inc||dec).closest('.cart-line'); var span=line && line.querySelector('.stepper span'); cur=span?parseInt(span.textContent,10):1; }
      if(isNaN(cur)) cur=1;
      var next=inc?cur+1:Math.max(0,cur-1);
      queueChange(key, next, next===0?0:350);
    }
    if(rm){ queueChange(rm.getAttribute('data-remove'), 0, 0); }
    if(addv){
      if(addv.getAttribute('data-sk-busy')) return;
      addv.setAttribute('data-sk-busy','1');
      addId(addv.getAttribute('data-add-variant'),1).then(function(){ addv.removeAttribute('data-sk-busy'); });
    }
  });

  /* Checkout / View cart pressed while quantities are still saving: wait, then go. */
  document.addEventListener('click', function(e){
    var go=e.target.closest('[data-cart] a[href$="/checkout"], [data-cart] a.sk-view-cart');
    if(!go) return;
    if(!inflight && !hasPending()) return;
    e.preventDefault();
    Object.keys(timers).forEach(function(k){ clearTimeout(timers[k]); delete timers[k]; });
    idleCbs.push(function(){ window.location.href=go.href; });
    pump();
  });

  /* ---------- Product form ---------- */
  document.querySelectorAll('form[action$="/cart/add"], form.product-form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(form.__skAdding) return; /* ignore a second submit while the first is running */
      form.__skAdding=true;
      var btn=form.querySelector('[name="add"]'); if(btn){ btn.setAttribute('disabled','disabled'); }
      postAdd(new FormData(form), false)
        .then(function(){ form.__skAdding=false; if(btn){ btn.removeAttribute('disabled'); } });
    });
  });
})();


/* ===== Product-card hover: second image + colour-swatch variant swap (Sunkissed) ===== */
(function(){
  if(window.__skCardHover) return; window.__skCardHover=1;
  var CSS='.product-card .media .sk-ph-2{opacity:0;transition:opacity .35s ease;pointer-events:none;}'
    +'@media (hover:hover){.product-card:hover .media .sk-ph-2{opacity:1;}}'
    +'.product-card[data-swatch-engaged] .media .sk-ph-2{opacity:0 !important;}'
    +'.product-card a.swatch,.product-card button.swatch{box-sizing:border-box;-webkit-appearance:none;appearance:none;border:0;padding:0;margin:0;cursor:pointer;display:inline-block;text-decoration:none;}'
    +'.product-card .swatch.is-active{box-shadow:0 0 0 2px #fff,0 0 0 4px var(--ink,#1c1c1c);}';
  var st=document.createElement('style'); st.setAttribute('data-card-hover',''); st.appendChild(document.createTextNode(CSS)); document.head.appendChild(st);
  function primaryOf(card){ return card.querySelector('[data-card-primary]'); }
  function rememberOrig(img){ if(img && !img.getAttribute('data-orig')){ img.setAttribute('data-orig', img.getAttribute('src')); } }
  document.addEventListener('click', function(e){
    var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
    var card=sw.closest('.product-card'); if(!card) return;
    e.preventDefault();
    var img=primaryOf(card); rememberOrig(img);
    var src=sw.getAttribute('data-swatch-img'); var url=sw.getAttribute('data-swatch-url'); var vid=sw.getAttribute('data-swatch-variant');
    if(img && src){ img.src=src; }
    if(url){ card.querySelectorAll('a.media-link, .info a[href]').forEach(function(a){ a.setAttribute('href', url); }); }
    if(vid){ var qa=card.querySelector('[data-add-variant]'); if(qa){ qa.setAttribute('data-add-variant', vid); } }
    card.setAttribute('data-swatch-engaged','1');
    card.querySelectorAll('.swatch.is-active').forEach(function(x){ x.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });
  if(window.matchMedia && window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mouseover', function(e){
      var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
      var card=sw.closest('.product-card'); if(!card) return; var img=primaryOf(card); if(!img) return;
      if(card.querySelector('.swatch.is-active')) return;
      rememberOrig(img); img.src=sw.getAttribute('data-swatch-img'); card.setAttribute('data-swatch-engaged','1');
    });
    document.addEventListener('mouseout', function(e){
      var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
      var card=sw.closest('.product-card'); if(!card) return; var img=primaryOf(card); if(!img) return;
      if(card.querySelector('.swatch.is-active')) return;
      var orig=img.getAttribute('data-orig'); if(orig){ img.src=orig; } card.removeAttribute('data-swatch-engaged');
    });
  }
})();
